var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomKidsRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 61,
    viewBox: "0 0 82 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_9776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 27.8003H0.75V54.1503H9.25V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 27.8003H9.25V54.1503H17.75V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 27.8003H17.75V54.1503H26.25V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74 27.8003H26.24V54.1503H34.74V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.24 27.8003H34.74V54.1503H43.24V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.74 27.8003H43.24V54.1503H51.74V27.8003Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 21.1602V60.7902",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.74 21.1602V60.7902",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5499 10.1999C32.5499 6.7199 29.73 3.8999 26.25 3.8999C22.77 3.8999 19.95 6.7199 19.95 10.1999V14.1799",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.24 0V11.89",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3601 9.30016C68.3601 5.77016 71.2201 2.91016 74.7501 2.91016C78.2801 2.91016 81.1401 5.77016 81.1401 9.30016V60.7902",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6601 15.34C74.6601 11.86 71.8401 9.04004 68.3601 9.04004C64.8801 9.04004 62.0601 11.86 62.0601 15.34H74.6701H74.6601Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.03 60.2901C66.3327 60.2901 69.0101 57.6127 69.0101 54.3101C69.0101 51.0074 66.3327 48.3301 63.03 48.3301C59.7274 48.3301 57.05 51.0074 57.05 54.3101C57.05 57.6127 59.7274 60.2901 63.03 60.2901Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.54 58.2501C58.54 58.2501 61.11 52.3401 68.1 51.1401",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0901 49.8101C59.0901 49.8101 65.8301 51.2601 66.9501 58.8101",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.88,
    height: 61.04,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomKidsRoom);
export default __webpack_public_path__ + "static/media/roomKidsRoom.b7fd9e4af5018c715ebb58338b4dc344.svg";
export { ForwardRef as ReactComponent };